// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"114":"bfd1d536","158":"974e9714"}[chunkId] + ".chunk.css";
};